"use client";

import { ActionCard } from "@/components/ActionCard";
import { Copy, Sparkles } from "lucide-react";

export function CopyToLLMCard() {
  const header = (
    <div className="mb-4 w-full aspect-[16/9] rounded-lg border border-border/60 bg-muted/10 flex items-center justify-center p-4">
      <div className="flex flex-col items-center gap-3 w-full max-w-xs">
        {/* Copy Button Preview */}
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-md border border-border/60 bg-background/80 text-[11px] text-muted-foreground">
          <Copy className="h-3 w-3" />
          <span>Copy to LLM</span>
        </div>

        {/* Arrow */}
        <div className="text-muted-foreground/50">↓</div>

        {/* Chat Response Preview */}
        <div className="w-full rounded-lg border border-border/60 bg-background/60 p-3">
          <div className="flex items-start gap-2">
            <Sparkles className="h-4 w-4 text-purple-500 mt-0.5" />
            <div className="flex-1">
              <div className="text-[11px] font-medium text-foreground">
                Fixing 6 issues...
              </div>
              <div className="mt-1.5 space-y-1">
                <div className="h-1.5 w-full rounded bg-muted/50 animate-[shimmer_2s_ease-in-out_infinite] bg-[length:200%_100%] bg-gradient-to-r from-muted/50 via-muted to-muted/50" />
                <div className="h-1.5 w-3/4 rounded bg-muted/50 animate-[shimmer_2s_ease-in-out_infinite_0.2s] bg-[length:200%_100%] bg-gradient-to-r from-muted/50 via-muted to-muted/50" />
                <div className="h-1.5 w-5/6 rounded bg-muted/50 animate-[shimmer_2s_ease-in-out_infinite_0.4s] bg-[length:200%_100%] bg-gradient-to-r from-muted/50 via-muted to-muted/50" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom keyframes */}
      <style jsx>{`
        @keyframes shimmer {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
      `}</style>
    </div>
  );

  return (
    <ActionCard
      ariaLabel="AI-powered fixes"
      title="AI-powered fixes"
      subtitle="Copy issues to ChatGPT or Claude. Get exact code changes to fix every problem automatically."
      header={header}
    />
  );
}
